import React from "react";
import "./LazyLoader.css";

const LazyLoader = () => {
  return (
    <div className="lazy-loader-container">
      <div className="loader"></div>
      <p>Loading...</p>
    </div>
  );
};

export default LazyLoader;
